import { CONTAINER_PADDING_ON_SIDES } from './constants';
import { isTileHiddenToTheLeft } from './is-tile-hidden-to-the-left';
import { isTileHiddenToTheRight } from './is-tile-hidden-to-the-right';

export const scrollTileHorizontallyIntoView = (container: HTMLElement, tile: HTMLElement) => {
    if (isTileHiddenToTheLeft(container, tile)) {
        container.scrollTo({ left: tile.offsetLeft - CONTAINER_PADDING_ON_SIDES });
    }
    if (isTileHiddenToTheRight(container, tile)) {
        container.scrollTo({ left: tile.offsetLeft + tile.clientWidth - container.clientWidth + CONTAINER_PADDING_ON_SIDES });
    }
};
